/**
 *
 * common helper
 *
 */

import { TIME_SPENT } from '../components/SectionResult/constants';

export function pluralize(count, noun, suffix = 's') {
  return `${count} ${noun}${parseInt(count, 10) !== 1 ? suffix : ''}`;
}

export function sortArrayOfObjectsByKey(inputObject, key, order = 'asc') {
  return inputObject.sort((a, b) => {
    const valueA = key === TIME_SPENT ? a[key] ?? 0 : a[key];
    const valueB = key === TIME_SPENT ? b[key] ?? 0 : b[key];

    // handling undefined key value pairs
    if (valueA === undefined && valueB === undefined) return 0;
    if (valueA === undefined) return order === 'asc' ? 1 : -1;
    if (valueB === undefined) return order === 'asc' ? -1 : 1;

    if (order === 'desc') {
      if (valueA > valueB) return -1;
      if (valueA < valueB) return 1;
      return 0;
    }
    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  });
}
